import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/timeline/index.js
// module id = 1402
// module chunks = 0